"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*

  this is the main (and only) public entry point to the application from the browser
  debug, info, warn, error, and RequestLogger are exported for isomorphic
  compatibility with the nodejs entrypoiny (node.js)

*/
var BaseLogger = require('./logger');

var sanitize = require('./sanitize');

var constants = require('./constants');

var levels = require('./levels');
/**
 * The client cannot determine the app name or log level using configurator/configment right now it needs to be
 * set manually. In the case where it is not, we provide a sensible default.
 */


var configuration = {
  singletonConfig: {},
  get: function get() {
    return Object.assign({}, this.singletonConfig);
  },
  set: function set(config) {
    this.singletonConfig = Object.assign({}, config);
  },
  update: function update(config) {
    Object.assign(this.singletonConfig, config);
  },
  reset: function reset() {
    this.set({
      level: 'info',
      appName: 'adc'
    });
  }
};
configuration.reset();
/**
 * Styles we use to add minor style to browser console logging.
 */

var baseStyles = "\n  color: #fff;\n  text-transform: uppercase;\n  padding: 3px 6px;\n".trim();
var levelStyles = {
  debug: "".concat(baseStyles, "\n  background-color: ").concat(constants.BROWSER_DEBUG_COLOR, ";\n  ").trim(),
  info: "".concat(baseStyles, "\n  background-color: ").concat(constants.BROWSER_INFO_COLOR, ";\n  ").trim(),
  warn: "".concat(baseStyles, "\n  background-color: ").concat(constants.BROWSER_WARN_COLOR, ";\n  ").trim(),
  error: "".concat(baseStyles, "\n  background-color: ").concat(constants.BROWSER_ERROR_COLOR, ";\n  ").trim()
};

var BrowserLogger = /*#__PURE__*/function (_BaseLogger) {
  _inherits(BrowserLogger, _BaseLogger);

  var _super = _createSuper(BrowserLogger);

  function BrowserLogger() {
    _classCallCheck(this, BrowserLogger);

    return _super.apply(this, arguments);
  }

  _createClass(BrowserLogger, [{
    key: "_logAtLevel",
    value: function _logAtLevel(level) {
      for (var _len = arguments.length, messages = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        messages[_key - 1] = arguments[_key];
      }

      var appName = configuration.get().appName;
      var loggerPrefix = null;

      if (messages.length > 1 && messages[0].startsWith(constants.LOGGER_REFERENCE_PREFIX)) {
        loggerPrefix = messages[0].replace(constants.LOGGER_REFERENCE_PREFIX, '').replace(constants.LOGGER_REFERENCE_SUFFIX, '').trim();
        messages = messages.slice(1);
      }

      messages = messages.map(function (arg) {
        return sanitize(arg);
      });

      if (levels[level] >= levels[configuration.get().level]) {
        var _console;

        // eslint-disable-next-line no-console
        (_console = console).log.apply(_console, ["%c".concat(loggerPrefix || appName), levelStyles[level]].concat(_toConsumableArray(messages)));
      }
    }
  }], [{
    key: "forModule",
    value: function forModule(modReference) {
      return new BrowserLogger(modReference);
    }
  }]);

  return BrowserLogger;
}(BaseLogger);

function RequestLogger() {
  this.logger = BrowserLogger.forModule('RequestLogger');

  this.request = this.response = function () {
    var _this$logger;

    (_this$logger = this.logger).info.apply(_this$logger, arguments); // eslint-disable-line no-console

  };
}
/**
 * Match the Isomorphic API
 */


BrowserLogger.prototype.RequestLogger = RequestLogger;
BrowserLogger.prototype.configuration = configuration; // Wish we could use Reflection for this but our apps don't have this rule enabled in babel...

BrowserLogger.prototype.forModule = BrowserLogger.forModule;
module.exports = new BrowserLogger();